import React, { useEffect, lazy, createElement } from 'react';
import { MapPin, Mail } from 'lucide-react';
export function ContactSection() {
  useEffect(() => {
    // Load Calendly script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      // Cleanup script on unmount
      document.body.removeChild(script);
    };
  }, []);
  return <section className="py-16 sm:py-20 lg:py-24 bg-[#0f2424]" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="text-center mb-12 sm:mb-16" data-id="element-53">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6" data-id="element-54">
            Contact Us
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12" data-id="element-55">
          {/* Left Column - Get In Touch */}
          <div data-id="element-56">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8" data-id="element-57">
              Get In Touch
            </h3>

            <div className="space-y-5 sm:space-y-6 mb-6 sm:mb-8" data-id="element-58">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-59">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center flex-shrink-0" data-id="element-60">
                  <MapPin className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5]" data-id="element-61" />
                </div>
                <div data-id="element-62">
                  <h4 className="text-base sm:text-lg font-semibold text-white mb-1" data-id="element-63">
                    Our Location
                  </h4>
                  <p className="text-sm sm:text-base text-gray-400" data-id="element-64">
                    Orlando, FL
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4" data-id="element-65">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-lg bg-[#4fd1c5]/10 flex items-center justify-center flex-shrink-0" data-id="element-66">
                  <Mail className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5]" data-id="element-67" />
                </div>
                <div data-id="element-68">
                  <h4 className="text-base sm:text-lg font-semibold text-white mb-1" data-id="element-69">
                    Email
                  </h4>
                  <p className="text-sm sm:text-base text-gray-400 break-all" data-id="element-70">
                    info@laundryinvestors.com
                  </p>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="rounded-xl overflow-hidden border-4 border-[#1a3a3a] h-[300px] sm:h-[400px]" data-id="element-71">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d448193.95098418634!2d-81.64010815!3d28.538336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e773d8fecdbc77%3A0xac3b2063ca5bf9e!2sOrlando%2C%20FL!5e0!3m2!1sen!2sus!4v1234567890" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-72"></iframe>
            </div>
          </div>

          {/* Right Column - Calendly Embed */}
          <div className="bg-[#0b1a1a] border border-gray-800 rounded-2xl p-6 sm:p-8" data-id="element-73">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6" data-id="element-74">
              Schedule a Meeting
            </h3>

            {/* Calendly inline widget */}
            <div className="calendly-inline-widget rounded-lg overflow-hidden" data-url="https://calendly.com/dj-getdealflow/laundry-investors-intro" style={{
            minWidth: '320px',
            height: '700px'
          }} data-id="element-75"></div>
          </div>
        </div>
      </div>
    </section>;
}